import { HttpMethod } from '@guiker/http'

const BASE_PATH = '/webhook'

export const routes = {
  handlePlaidWebhook: {
    path: `${BASE_PATH}/plaid`,
    method: HttpMethod.POST,
    responseValidator: (response: unknown) => Promise.resolve(response as unknown),
    payloadValidator: (payload: unknown) => Promise.resolve(payload as any),
  },
}
